import { ReactComponent as CloseIcon } from "../../icons/closeWhite.svg";
import { MouseEvent } from "react";
import classes from "./removableTag.module.css";
import SecondaryButton from "../SecondaryButton";

interface IProps {
  tag: string;
  variant?: "default" | "active";
  onRemove?: (tag: string) => (event: MouseEvent) => void;
}

const RemovableTag = ({ tag, variant, onRemove }: IProps) => {
  return (
    <SecondaryButton variant={variant}>
      <span>{tag}</span>
      {onRemove && (
        <span className={classes.remove} onClick={onRemove(tag)}>
          <CloseIcon className={classes.removeIcon} />
        </span>
      )}
    </SecondaryButton>
  );
};

export default RemovableTag;
